import { createRoute, useNavigate } from '@tanstack/react-router'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import rootRoute from '../rootRoute'
import AdminTabs from './AdminTabs'
import { adminRouteLoader } from '@/lib/auth'
import AdminUsers from '@/components/admin/AdminUsers'
import { Button, Row, errorToast, spacing } from '@/components/ui'
import { $api } from '@/lib/fetch'

function AdminUsersView() {
  const navigate = useNavigate()
  const { last_id } = adminUsersRoute.useSearch()

  const { isLoading, data, error, isError } = $api.useQuery(
    'get',
    '/api/users',
    {
      params: { query: { limit: 20, last_id } },
    },
  )

  if (isError) {
    errorToast('Impossible de récupérer les utilisateurs', error)
  }

  const nextLastId = data?.next_last_id

  const goNext = () => {
    if (nextLastId == null) return
    navigate({
      to: '/admin/users',
      search: () => ({ last_id: nextLastId }),
    } as never)
  }

  const goPrev = () => window.history.back()

  return (
    <div
      style={{
        maxWidth: 'var(--container-max)',
        margin: '0 auto',
        padding: 'var(--space-8) var(--gutter) var(--space-20)',
      }}
    >
      <AdminTabs />
      <div className="oumma-overline" style={{ marginBottom: spacing.sm }}>
        Espace admin
      </div>
      <h1 style={{ fontSize: 'var(--text-h1)', margin: '0 0 28px' }}>
        Utilisateurs
      </h1>

      {isLoading ? (
        <p style={{ color: 'var(--ink-2)' }}>Chargement des utilisateurs…</p>
      ) : isError ? (
        <p style={{ color: 'var(--danger)' }}>
          Une erreur est survenue: {JSON.stringify(error)}
        </p>
      ) : (
        <>
          <AdminUsers users={data?.users ?? []} />
          <Row gap="md" justify="flex-end" style={{ marginTop: spacing.lg }}>
            <Button
              variant="secondary"
              size="sm"
              iconLeft={<ChevronLeft size={15} />}
              onClick={goPrev}
              disabled={last_id == null}
            >
              Précédent
            </Button>
            <Button
              variant="secondary"
              size="sm"
              iconRight={<ChevronRight size={15} />}
              onClick={goNext}
              disabled={nextLastId == null}
            >
              Suivant
            </Button>
          </Row>
        </>
      )}
    </div>
  )
}

export const adminUsersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/users',
  validateSearch: (search: Record<string, unknown>) => ({
    last_id: search.last_id ? Number(search.last_id) : undefined,
  }),
  loader: adminRouteLoader,
}).lazy(() => import('./AdminUsersView.lazy').then((m) => m.Route))

export default AdminUsersView
